import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';
import {LibroDetalle} from 'src/app/modal/catalogo/libro-detalle';
import { NovedadesResponse } from 'src/app/modal/catalogo/novedades-response';
import { NovedadesService } from 'src/app/service/catalogo/novedades.service';
import { CarritoService } from 'src/app/service/carrito/carrito.service';
import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { UsuarioService } from 'src/app/service/usuario/usuario.service';
import { CarritoHeader } from 'src/app/modal/carrito/carrito-header';
import { environment } from 'src/environments/environment';
import { LibroDetalleBean } from 'src/app/modal/catalogo/libro-detalle-bean';
import { ProtectedImageService } from 'src/app/service/catalogo/protected-image.service';
import { ProtectedImageResponse } from 'src/app/modal/catalogo/protected-image-response';
import { CurrencyService, CurrencyInfo } from 'src/app/service/currency/currency.service';
import { EstadisticaService } from 'src/app/service/estadistica/estadistica.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-detalle',
  templateUrl: './detalle.component.html',
  styleUrls: ['./detalle.component.scss']
})
export class DetalleComponent implements OnInit, OnDestroy {
  idLibro:string;
  flgAgregar:string = "0";
  detalleLibro:LibroDetalle = new LibroDetalle();
  stockLibro=0;
  librosRecomendados:NovedadesResponse;
  cantidadLibro:number=1;
  precioTotal:number=1;
  modalidadActiva="Natural";
  currencyActiva = 'S/.'; // Moneda de la modalidad activa

  // Currency service integration
  private currencySubscription: Subscription;
  currentCurrency: CurrencyInfo;
  comercialMsg: string;
  urlImagen:string;
  // daet ini
  urlImagen2:string;
  urlImagen3:string;
  // daet fin
  tagPublicacion:any;
  listModalidad:any;
  modalidadId:any="1";
  // daet1 ini
  relacionados:any;
  // daet fin
  Arr = Array;
  protectedImages: Map<string, ProtectedImageResponse> = new Map();
  private visitaActivoId: string = null;

  constructor(  private route: ActivatedRoute,
    private novedadesService:NovedadesService ,
    private router : Router,
    private carritoService:CarritoService ,
    private usuarioService:UsuarioService,
    private utilitarioService: UtilitarioService,
    private protectedImageService: ProtectedImageService,
    private currencyService: CurrencyService,
    private estadisticaService: EstadisticaService) {
      //daet
    // console.log("params.idLibro->"+this.route.snapshot.params.idLibro); 
    // console.log("idSeleccionado->"+this.utilitarioService.idSeleccionado);
    this.idLibro= this.route.snapshot.params.idLibro==null || this.route.snapshot.params.idLibro==undefined ?this.utilitarioService.idSeleccionado:this.route.snapshot.params.idLibro;
    //this.idLibro=this.route.snapshot.params.idLibro.split("-")[0];
    // console.log("this.idLibro.final->"+this.idLibro);
    // daet
    //this.idLibro=this.route.snapshot.params.idLibro
  }

  obtenerDetalleLibro(id){
    id=id==null?this.utilitarioService.idSeleccionado:id;
    // console.log("idSeleccionado"+this.utilitarioService.idSeleccionado);

    if (this.cantidadLibro<1){
      this.cantidadLibro = 0;
    }

    if(this.cantidadLibro>10){
      this.cantidadLibro = 10;
      this.utilitarioService.toastrInfo("cantidad maxíma : " + "10");
    }

    this.detalleLibro = new LibroDetalle();
    this.utilitarioService.loading=true;

    // Obtener userId si está logueado para determinar nacionalidad por tipo de documento
    const userId = this.usuarioService.obtenerIDSessionUsuario();
    // console.log('📋 [DETALLE] userId para determinar nacionalidad:', userId);

    if(this.cantidadLibro>0){
      this.novedadesService.obtenerDetalleLibro(id, userId).subscribe(data=>{
        // if(this.cantidadLibro>Number(this.detalleLibro.response.list[0].stock)){
        //   this.utilitarioService.toastrWarning("Cantidad Mayor a Stock");
        //   return false;
        // }

        this.detalleLibro = data;
        // console.log(data);

        // ⚠️ asegúrate de que response.list[0] exista:
        const item = this.detalleLibro?.response?.list?.[0];
        if (item) {
          // Cargar imagen protegida
          if (item.activoId) {
            this.loadProtectedThumbnail(String(item.activoId));
            this.urlImagen = this.getProtectedImageUrl(String(item.activoId)) || '';
          }

          // Registrar visita para estadísticas (se ejecuta tras 3s de permanencia)
          this.visitaActivoId = String(item.id || item.activoId || id);
          this.estadisticaService.registrarVisita(this.visitaActivoId, 'LIBRO');
        }

        this.precioTotal = Number((this.cantidadLibro * Number(this.detalleLibro.response.list[0].price)).toFixed(2));
  
        if(Number(this.detalleLibro.response.list[0].quantity)<10){
          this.stockLibro = Number(this.detalleLibro.response.list[0].quantity);
        }

      
        else{
          this.stockLibro = 10;          
        }

        
        if(this.detalleLibro.response.list[0].stock=="0"){
          this.cantidadLibro = Number(this.detalleLibro.response.list[0].stock);
        }
       
        // daet ini - ELIMINADO: método antiguo con tokenUserImagen (vulnerabilidad)
        // TODO: Migrar a sistema de imágenes protegidas si es necesario
        // this.urlImagen2 = this.imagen(this.detalleLibro.response.list[0].previewUrl);
        // this.urlImagen3 = this.imagen(this.detalleLibro.response.list[0].originalUrl);
        // daet fin
        this.tagPublicacion = this.detalleLibro.response.list[0].tags.split(",");
        // Usar el array de modalidades filtradas del backend (basado en geolocalización)
        // en lugar del string modalidadName que contiene todas las modalidades
        const modalidadesArray = this.detalleLibro.response.list[0].modalidades;
        if (modalidadesArray && modalidadesArray.length > 0) {
          this.listModalidad = modalidadesArray.map(m => m.name);
          // console.log('📋 [DETALLE] Modalidades filtradas del backend:', this.listModalidad);
        } else {
          // Fallback al string solo si no hay array de modalidades
          this.listModalidad = this.detalleLibro.response.list[0].modalidadName.split("/");
          // console.log('📋 [DETALLE] Usando fallback modalidadName:', this.listModalidad);
        }
        // console.log("tagPublicacion",this.tagPublicacion);
        // daet1 ini
        this.relacionados=this.detalleLibro.response.list[0].relacionados;
        // daet1 fin

        // Auto-seleccionar modalidad según la moneda detectada por geolocalización
        if (this.detalleLibro.response.list[0].modalidades && this.detalleLibro.response.list[0].modalidades.length > 0) {
          this.autoSelectModalidadByCurrency();
        }

        this.utilitarioService.loading=false;

      })
    }

    else{
      this.cantidadLibro=0;
    }
    
  }

  obtenerDetalleLibroAgregarLibros(id){
    
    // console.log("cantidadLibro",this.cantidadLibro,Number(this.detalleLibro.response.list[0].quantity));
    if(this.cantidadLibro>Number(this.detalleLibro.response.list[0].quantity) || this.cantidadLibro==0){
      this.utilitarioService.toastrWarning("Cantidad debe ser estar entre 1 y "+this.stockLibro);
      this.cantidadLibro = this.stockLibro;
      return false;
    }
   
    if (this.cantidadLibro<1){
      this.cantidadLibro = 0;
    }

    if(this.cantidadLibro>10){
      this.cantidadLibro = 10;
      this.utilitarioService.toastrInfo("cantidad maxíma : " + "10");
    }
  


    this.detalleLibro = new LibroDetalle();
    this.utilitarioService.loading=true;

    // Obtener userId si está logueado para determinar nacionalidad por tipo de documento
    const userId = this.usuarioService.obtenerIDSessionUsuario();

    if(this.cantidadLibro>0){
      this.novedadesService.obtenerDetalleLibro(id, userId).subscribe(data=>{
        this.detalleLibro = data;
        // console.log(data);

        
        this.precioTotal = Number((this.cantidadLibro * Number(this.detalleLibro.response.list[0].price)).toFixed(2));
  
        if(Number(this.detalleLibro.response.list[0].quantity)<10){
          this.stockLibro = Number(this.detalleLibro.response.list[0].quantity);
        }

      
        else{
          this.stockLibro = 10;          
        }

        
        if(this.detalleLibro.response.list[0].stock=="0"){
          this.cantidadLibro = Number(this.detalleLibro.response.list[0].stock);
        }


        this.utilitarioService.loading=false;

      })
    }

    else{
      this.cantidadLibro=0;
    }
    
  }

  obtenerLibrosRecomendados(id){
    this.librosRecomendados = new NovedadesResponse();
    this.novedadesService.obtenerLibrosRecomendados(id).subscribe(data=>{
      this.librosRecomendados = data;
    })
  }
  slideConfig = {"slidesToShow": 4, "slidesToScroll": 1,"responsive": [
    {
      'breakpoint': 600,
      'settings': {
        'slidesToShow': 1
              }
    }
      
    
  ]};
  cargarDetalleLibro(id){
    this.obtenerDetalleLibro(id);
    // this.obtenerLibrosRecomendados(id); // Comentado - sección de recomendados no se usa
  }
  
  // daet
  prueba(busq){
    // console.log("prueba:"+busq);

    // Limpiar espacios del tag
    const cleanTag = busq.trim().toLowerCase();

    this.utilitarioService.busqueda = cleanTag;
    this.utilitarioService.tipobusqueda="tag";

    // Determinar la ruta base según la categoría actual
    let baseRoute = '/fotografias'; // Default
    const categoryId = this.utilitarioService.idCategoria || this.novedadesService.idCategoria;

    if (categoryId === '2') {
      baseRoute = '/portadas';
    } else if (categoryId === '3') {
      baseRoute = '/consultas';
    }

    // Navegar usando el nuevo formato de URL con parámetros de consulta
    this.router.navigate([baseRoute], {
      queryParams: { q: cleanTag, page: 1 },
    });
  }
  //daet1
  prueba1(busq){
    // console.log("prueba1:"+busq);
    //this.utilitarioService.busqueda = busq;
    //this.utilitarioService.tipobusqueda="tag";
    this.obtenerDetalleLibro(busq);
    this.router.navigate(['/d/'+busq]);
  }
  generaNss() {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < charactersLength; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }  
  agregarCarrito(){
    this.flgAgregar = "1";
    let idLibro = this.detalleLibro.response.list[0].id;
    let cantidad = this.cantidadLibro;
    let tipoProducto = "1";
    let sizeID ="0";

    let libroArray = {};
    libroArray ={id:idLibro,cantidad:cantidad,tipoProducto:tipoProducto,sizeID:sizeID,modalidadId:this.modalidadId};

    let carritoSesionTemp = new CarritoHeader();
    carritoSesionTemp = this.carritoService.obtenerCarritoCompras();
    for(let i=0;i<carritoSesionTemp.lista.length;i++){      
      if(carritoSesionTemp.lista[i].id==idLibro && this.modalidadId==carritoSesionTemp.lista[i].modalidadId){
        let cantidadTemp = carritoSesionTemp.lista[i].cantidad;
        let cantidadSumaTemp = Number(cantidadTemp) + Number(cantidad);
        if(Number(cantidadSumaTemp)>this.stockLibro){
          // console.log("cantidadSumaTemp:"+cantidadSumaTemp+"-->this.stockLibro:"+this.stockLibro);
          // daet1
          //this.utilitarioService.toastrWarning("El limite de stock es "+this.stockLibro);
          this.utilitarioService.toastrWarning("Ya se seleccionó la foto "+this.stockLibro);
          return false;
        }
      }
    }
    if(carritoSesionTemp.lista)
    this.carritoService.agregarCarrito(libroArray);
    this.utilitarioService.toastrSuccess('Agregado al carrito');
  }


  imagen(img: String) {
    // console.log("this.detalleLibro.response.list[0]", this.detalleLibro.response.list[0]);


    if (!img) {
      console.warn("Advertencia: La imagen es null o undefined.");
      return "";  // Retornar una cadena vacía para evitar errores
    }
    return img.replace(/_=2?/, "");
  }
  



  onComprar(){
    if(this.usuarioService.obtenerSesionUsuario()){
      let idLibro = this.detalleLibro.response.list[0].id;
      let cantidad = this.cantidadLibro;
      let tipoProducto = "1";
      let sizeID ="0";
      let libroArray = {};

      cantidad = this.cantidadLibro;

      this.carritoService.obtenerCantidadCarrito();

      // Validar si el producto ya está en el carrito y excede el stock
      let carritoSesionTemp = new CarritoHeader();
      carritoSesionTemp = this.carritoService.obtenerCarritoCompras();
      if (carritoSesionTemp && carritoSesionTemp.lista) {
        for (let i = 0; i < carritoSesionTemp.lista.length; i++) {
          if (
            carritoSesionTemp.lista[i].id == idLibro &&
            this.modalidadId == carritoSesionTemp.lista[i].modalidadId
          ) {
            // El producto ya está en el carrito, mostrar aviso e ir directo a procesar pago
            this.utilitarioService.toastrInfo('El producto ya está en tu carrito');
            this.router.navigate(['/procesarpago']);
            return;
          }
        }
      }

      libroArray = {id:idLibro,cantidad:cantidad,tipoProducto:tipoProducto,sizeID:sizeID,modalidadId:this.modalidadId};

      // Agregar al carrito y procesar pago
      this.carritoService.agregarCarrito(libroArray);
      this.router.navigate(['/procesarpago']);
    }
    else{
      this.utilitarioService.toastrWarning("Necesita iniciar sesión")
    }
  }  
  cambiarModalidad(modalidad){
    let modalidades:LibroDetalleBean =  this.detalleLibro.response.list[0];    
    this.modalidadActiva = modalidad;

    let precio = modalidades.modalidades.find(data=>
      data.name==modalidad
    ).price;

    this.modalidadId = modalidades.modalidades.find(data=>
      data.name==modalidad
    ).id;

    this.precioTotal = Number((this.cantidadLibro * Number(precio)).toFixed(2));

    // daet1 ini
    // console.log("modalidad:"+modalidad);
    if (modalidad=="Comercial Extranjero"){
      this.comercialMsg="Comercial Extranjero";
    }  
    if (modalidad=="Comercial Nacional"){
      this.comercialMsg="Comercial Nacional";
    }
    if (modalidad=="Natural"){
      this.comercialMsg="Natural";
    }  
    // daet1 fin

  }
  modalidadCss(modalidad){   
   
    if(modalidad==this.modalidadActiva){
      return "active"
    }
    return ''
  }
  slickInit(e) {
    //console.log('slick initialized');
  }
  
  breakpoint(e) {
    //console.log('breakpoint');
  }
  
  afterChange(e) {
    //console.log('afterChange');
  }
  
  beforeChange(e) {
    //console.log('beforeChange');
  }

  sharedFacebook(){
    let url = window.location.href;
    let urlShared = "http://www.facebook.com/sharer.php?u="+url;
    window.open(urlShared,"_blank");
  }
  sharedWhatsapp(){
    let url = window.location.href;
    let urlShared = "https://api.whatsapp.com/send?text="+url;
    window.open(urlShared,"_blank");
  }
  sharedTwitter(){
    let url = window.location.href;
    let urlShared = "https://twitter.com/intent/tweet?text=Archivo Histórico del Diario Oficial El Peruano&url="+url;
    window.open(urlShared,"_blank");
  }
  
  loadProtectedThumbnail(imageId: string): void {
    // Verificar si ya existe el token y aún es válido
    if (this.protectedImages.has(imageId)) {
      const existingImage = this.protectedImages.get(imageId);
      const now = Date.now();
      const CACHE_DURATION = 5 * 60 * 1000; // 5 minutos de cache

      if (existingImage && existingImage.loadedAt && (now - existingImage.loadedAt) < CACHE_DURATION) {
        // console.log('Token de imagen reutilizado desde cache:', imageId);
        return; // Ya existe y es válido
      }
    }

    // Solo solicitar nuevo token si no existe o ha expirado
    this.protectedImageService.getProtectedThumbnail(imageId).subscribe({
      next: (response) => {
        response.loadedAt = Date.now(); // Agregar timestamp de carga
        this.protectedImages.set(imageId, response);
        // Actualizar la URL de la imagen cuando se cargue
        this.urlImagen = response.protectedThumbnailUrl;
        // console.log('Token cargado para imagen:', imageId);
      },
      error: (error) => {
        console.error('Error cargando imagen protegida:', error);
      }
    });
  }

  getProtectedImageUrl(imageId: string): string | null {
    const protectedImage = this.protectedImages.get(imageId);
    return protectedImage?.protectedThumbnailUrl || null;
  }

  clearProtectedImagesCache(): void {
    // console.log('Limpiando cache de imágenes protegidas para nueva carga');
    // Solo limpiar tokens expirados en lugar de limpiar todo
    const now = Date.now();
    const CACHE_DURATION = 5 * 60 * 1000; // 5 minutos

    for (const [imageId, imageData] of this.protectedImages.entries()) {
      if (imageData.loadedAt && (now - imageData.loadedAt) > CACHE_DURATION) {
        this.protectedImages.delete(imageId);
        // console.log('Token expirado eliminado para imagen:', imageId);
      }
    }
  }


  

  ngOnInit(): void {
    // Inicializar moneda actual
    this.currentCurrency = this.currencyService.currentCurrency;

    // Suscribirse a cambios de moneda
    this.currencySubscription = this.currencyService.currency$.subscribe(currency => {
      this.currentCurrency = currency;
      this.currencyActiva = currency.symbol;
      // console.log('💰 [DETALLE] Moneda actualizada:', currency.code, currency.symbol);

      // Si ya tenemos modalidades cargadas, auto-seleccionar la correcta
      if (this.detalleLibro?.response?.list?.[0]?.modalidades) {
        this.autoSelectModalidadByCurrency();
      }
    });

    this.obtenerDetalleLibro(this.idLibro);
    // this.obtenerLibrosRecomendados(this.idLibro); // Comentado - sección de recomendados no se usa
   // //console.log("this",this.idLibro)
  }

  ngOnDestroy(): void {
    // Cancelar visita pendiente si el usuario se fue antes de 3 segundos
    if (this.visitaActivoId) {
      this.estadisticaService.cancelarVisita(this.visitaActivoId, 'LIBRO');
    }

    // Limpiar suscripción al servicio de moneda
    if (this.currencySubscription) {
      this.currencySubscription.unsubscribe();
    }
  }

  /**
   * Auto-selecciona la modalidad según la recomendación del backend (basada en geolocalización).
   * El backend devuelve recommendedModalidadId y recommendedModalidadName según la IP del visitante.
   * - Visitante de Perú (PE) → modalidad N o CN (Soles)
   * - Visitante extranjero → modalidad CE (Dólares)
   */
  autoSelectModalidadByCurrency(): void {
    if (!this.detalleLibro?.response?.list?.[0]?.modalidades) {
      return;
    }

    const item = this.detalleLibro.response.list[0];
    const modalidades = item.modalidades;

    // Usar exclusivamente la modalidad recomendada por el backend (basada en geolocalización del servidor)
    if (!item.recommendedModalidadId) {
      // console.log('💰 [DETALLE] Esperando recomendación del backend...');
      return;
    }

    const modalidadRecomendada = modalidades.find(m => m.id === item.recommendedModalidadId);

    if (!modalidadRecomendada) {
      // console.log('💰 [DETALLE] Modalidad recomendada no encontrada en la lista:', item.recommendedModalidadId);
      return;
    }

    // console.log('💰 [DETALLE] Modalidad del backend:', item.recommendedModalidadName,
    //   '- isPeruvianVisitor:', item.isPeruvianVisitor);

    // Aplicar la modalidad seleccionada
    this.modalidadActiva = modalidadRecomendada.name;
    this.modalidadId = modalidadRecomendada.id;
    this.currencyActiva = modalidadRecomendada.currency || 'S/.';

    // Recalcular precio total
    this.precioTotal = Number(
      (this.cantidadLibro * Number(modalidadRecomendada.price)).toFixed(2)
    );

    // Actualizar mensaje de modalidad comercial
    const modalidadName = modalidadRecomendada.name?.toLowerCase();
    if (modalidadName === 'ce' || modalidadName === 'comercial extranjero') {
      this.comercialMsg = 'Comercial Extranjero';
    } else if (modalidadName === 'cn' || modalidadName === 'comercial nacional') {
      this.comercialMsg = 'Comercial Nacional';
    } else {
      this.comercialMsg = 'Natural';
    }
  }

}
